module.exports = __webpack_public_path__ + "7c6abeb002c61e5fe5925e0e20f56f5e.pdf";